import { render, staticRenderFns } from "./store-list.vue?vue&type=template&id=24d18b00&scoped=true"
import script from "./store-list.vue?vue&type=script&lang=js"
export * from "./store-list.vue?vue&type=script&lang=js"
import style0 from "./store-list.vue?vue&type=style&index=0&id=24d18b00&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d18b00",
  null
  
)

export default component.exports